// src/App.jsx
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home/Home";
import Costalegre from "./pages/Costalegre/Costalegre";
 import Chapala from "./pages/Chapala/Chapala";
  import Tapalpa from "./pages/Tapalpa/Tapalpa";
   import PaisajeAgavero from "./pages/PaisajeAgavero/PaisajeAgavero";
// import Rioverde from "./pages/Rioverde";
 import AltosNorte from "./pages/AltosNorte/AltosNorte";
// import AltosSur from "./pages/AltosSur";
 import Lagunas from "./pages/Lagunas/Lagunas";
 import SierraOccidental from "./pages/SierraOccidental/SierraOccidental";
 import SierraDelTigre from "./pages/SierradelTigre/SierradelTigre";
 import CACS from "./pages/Cacs/Cacs.jsx";
  //import RioZula from "./pages/RioZula/RioZula.jsx";
// import SierraAmula from "./pages/SierraAmula";
// import Valles from "./pages/Valles";
// import Centro from "./pages/Centro";
// import Sur from "./pages/Sur";
// import Norte from "./pages/Norte";
import DescargasMunicipios from "./pages/DescargasMunicipios";
import Contacto from "./pages/Contacto/Contacto";
import RioZula from "./pages/RioZula/RioZula.jsx";
import { i } from "framer-motion/client";
import RioVerde from "./pages/RioVerde/RioVerde.jsx";
import FichasInformativas from "./pages/FichasInformativas.jsx"; 
// import usePageTracking from "./hooks/usePageTracking";
import PageTracker from "./components/PageTracker.jsx";
import Jira from "./pages/Jiras/Jira.jsx";
import TutorialNavegacion from "./components/TutorialNavegacion";

function App() {
  
  return (
    
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          

      <PageTracker />   {/* ✅ dentro del Router */}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/costalegre" element={<Costalegre />} />
            <Route path="/chapala" element={<Chapala />} />
            <Route path="/tapalpa" element={<Tapalpa />} />
             <Route path="/altosnorte" element={<AltosNorte />} />
             <Route path="/paisajeagavero" element={<PaisajeAgavero />} />
              <Route path="/sierraoccidental" element={<SierraOccidental />} />
              <Route path="/cacs" element={<CACS />} />
              <Route path="/riozula" element={<RioZula />} />
            <Route path="/rioverde" element={<RioVerde />} />
            <Route path="/lagunas" element={<Lagunas />} />
            <Route path="/fichas" element={<FichasInformativas />} />
              <Route path="/sierradeltigre" element={<SierraDelTigre />} />
              <Route path="/JIRA" element={<Jira />} />
              
           
            {/*  <Route path="/altossur" element={<AltosSur />} />
            
           
            <Route path="/sierraamula" element={<SierraAmula />} />
            <Route path="/valles" element={<Valles />} />
            <Route path="/centro" element={<Centro />} />
            <Route path="/sur" element={<Sur />} />
            <Route path="/norte" element={<Norte />} /> */}
            <Route path="/descargas/:regionId" element={<DescargasMunicipios />} />
            <Route path="/contacto" element={<Contacto />} />
          </Routes>
         

        </main>
        <TutorialNavegacion />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;


